import { render, staticRenderFns } from "./Modal_ASS_2_Weekly.vue?vue&type=template&id=639f10f6&scoped=true&"
import script from "./Modal_ASS_2_Weekly.vue?vue&type=script&lang=js&"
export * from "./Modal_ASS_2_Weekly.vue?vue&type=script&lang=js&"
import style0 from "./Modal_ASS_2_Weekly.vue?vue&type=style&index=0&id=639f10f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639f10f6",
  null
  
)

export default component.exports